import { TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE } from '../shared/abstract-boxes';

export function EmailRequestForNotificationBoxViewConstructor(services, callbacks, context) {


  let joint = services.joint;
  let companyId = context.companyId;
  let site = context.site;

  return joint.shapes.html.AbstractBoxElementView.extend({

    template: [
      '<div class="html-element">',
      '  <div class="box-content-container">',
      '    <div class="box-content-container">',
      '      <div class="question-text-content"></div>',
      '      <div class="question-edit-container"><span class="glyphicon glyphicon-pencil question-edit"></span></div>',
      '      <div class="email-conf-container">',
      '        <h2>' + services.$translate.instant('parameters/quick_replies/details/graph/email_request_for_notification_box/email_to_send') + '</h2>',
      '        <div class="box-content-title">' + services.$translate.instant('parameters/quick_replies/details/graph/email_request_for_notification_box/email_sender') + '</div>',
      '        <div class="box-content-indented email-sender"></div>',
      '        <div class="box-content-title">' + services.$translate.instant('parameters/quick_replies/details/graph/email_request_for_notification_box/email_subject') + '</div>',
      '        <div class="box-content-indented email-subject"></div>',
      '        <div class="box-content-title">' + services.$translate.instant('parameters/quick_replies/details/graph/email_request_for_notification_box/email_content') + '</div>',
      '        <div class="box-content-indented email-content"></div>',
      '        <div class="box-content-title">' + services.$translate.instant('parameters/quick_replies/details/graph/email_request_for_notification_box/email_landing_page_url') + '</div>',
      '        <div class="box-content-indented email-landing-page-url"></div>',
      '      </div>',
      '    </div>',
      '  </div>',
      '</div>'
    ].join(''),

    initialize: function () {
      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);

      // this.$box is initialized by the abstract superclass
      this.$box.find('.remove').on('click', this.model.remove.bind(this.model));
      this.$box.find('.question-edit').on('click', function (evt) {
        this.editBox();
      }.bind(this));
      this.setBoxHtmlContent();
      this.updateBox();
    },

    editBox: function () {
      function resultAction(result) {
        if (result.type === 'edit') {
          this.model.set('content', result.data.content);
          this.model.set('links', result.data.links);
          this.model.set('emailSender', result.data.emailSender);
          this.model.set('emailSubject', result.data.emailSubject);
          this.model.set('emailContent', result.data.emailContent);
          this.model.set('emailLinks', result.data.emailLinks);
          this.model.set('landingPageUrl', result.data.landingPageUrl);
        }
        this.setBoxHtmlContent();
        callbacks.updateSerializedGraph(this.model.graph);
        //Resize needed for both editing and deleting
        this.resizeQuestionBox();
      }

      let modalInstance = services.$uibModal.open({
        animation: true,
        template: require('./editEmailRequestForNotificationBox.modal.html'),
        controller: 'editEmailRequestForNotificationController',
        resolve: {
          companyId: companyId,
          site: site,
          content: () => this.model.get('content'),
          links: () => this.model.get('links'),
          emailSender: () => this.model.get('emailSender'),
          emailSubject: () => this.model.get('emailSubject'),
          emailContent: () => this.model.get('emailContent'),
          emailLinks: () => this.model.get('emailLinks'),
          landingPageUrl: () => this.model.get('landingPageUrl'),
        }
      });
      modalInstance.result.then(resultAction.bind(this));
    },

    setBoxHtmlContent: function () {
      // Update text content
      this.$box.find('.question-text-content').text(this.model.get('content'));

      // Update email configuration
      this.$box.find('.email-sender').text(this.model.get('emailSender'));
      this.$box.find('.email-subject').text(this.model.get('emailSubject'));
      this.$box.find('.email-content').text(this.model.get('emailContent'));
      this.$box.find('.email-landing-page-url').text(this.model.get('landingPageUrl'));
    },

    resizeQuestionBox: function () {
      if (services.JointjsOptimisationsFactory.logCallsToResize()) {
        console.warn('EmailRequestForNotificationBoxView - resizeQuestionBox()');
      }
      let box = this.model;
      let embeddedCells = box.getEmbeddedCells();
      let paddingTop = this.$box.find('.box-content-container').outerHeight();

      //Reposition and resize every item
      let ypos = paddingTop;
      for (let child of embeddedCells) {
        let childView = this.paper.findViewByModel(child);
        child.position(0, ypos, { parentRelative: true });
        let childHeight = childView.$box.outerHeight();
        child.resize(box.attributes.size.width, childHeight);
        ypos += childHeight;
      }

      box.fitEmbeds({ padding: { top: paddingTop, right: 0, bottom: 0, left: 0 } });
      callbacks.resizePaper();
    },

    createAnswer: function createAnswer(id, position = TMP_ELEMENT_POSITION, size = TMP_ELEMENT_SIZE) {
      let answer = new services.joint.shapes.html.Answer({
        id: id,
        position,
        size,
        answerType: 'email',
        notEditable: true
      });
      this.model.set('email_answer_id', id);

      this.model.embed(answer);
      return answer;
    },

  });
}
